import React, { useState } from 'react'
import { Col, Row, Button, Container, Card, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import api from '../api/api';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom'
import './AddUserBySupplier.css';

const AddUser = () => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");

    const [nameError, setNameErr] = useState("");
    const [emailError, setEmailErr] = useState("");
    const [mdpError, setPassErr] = useState("");
    const [confMdpErr, setconfMdpErr] = useState("");
    const [offerType, setOfferType] = useState(2);

    const validate = () => {
        let nameError = '';
        let emailError = '';
        let mdpError = '';
        let confMdpErr = '';
        if (!name) {
            nameError = t('cannot_be_blank');
            setNameErr(nameError)
        }
        if (!email) {
            emailError = t('cannot_be_blank');
            setEmailErr(emailError)
        }
        else if (typeof email !== 'undefined') {
            var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!mailformat.test(email)) {
                emailError = t('incorrect_email_format');
                setEmailErr(emailError)
            }
        }
        if (password.length < 6) {
            mdpError = t('password_min_length');
            setPassErr(mdpError)
        }
        if (password != confirmPass) {
            confMdpErr = t('passwords_dont_match');
            setconfMdpErr(confMdpErr)
        }
        if (emailError || nameError || mdpError || confMdpErr) {
            setEmailErr(emailError);
            setNameErr(nameError);
            setPassErr(mdpError);
            setconfMdpErr(confMdpErr)
            return false;
        }
        return true;
    };

    const handleSubmit = (event) => {
        event.preventDefault()

        const isValid = validate();
        if (isValid) {
            handleRegister()

        } else {
            return false;
        }
    }
    const handleRegister = () => {

        let data = {
            name: name,
            email: email,
            password: password,
            confirmPassword: confirmPass,
            offer_type: offerType,
        }

        api.post('/supplier/add-user', data)
            .then(res => {
                if (res.data.type && res.data.type == "danger") {
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: res.data.message
                    })
                    return false;
                }
                if (res.data.type && res.data.type == "warnning") {
                    swal({
                        icon: 'warning',
                        title: t('Oops...'),
                        text: res.data.message
                    })
                    resetForm()
                }
                if (res.data.type && res.data.type == "success") {
                    swal({
                        icon: 'success',
                        title: t('ok'),
                        text: t("Email sent check your inbox to confirm")
                    })
                    resetForm()

                }
            }).catch(() => {
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('error_add_user')
                })
                return false;
            })
    }
    const resetForm = () => {
        setName("");
        setEmail("");
        setPassword("");
        setConfirmPass("");
        setOfferType(2);
        setNameErr("");
        setEmailErr("");
        setPassErr("");
        setconfMdpErr("");
    }


    return (
        <>
             <Container fluid className="supplier-adduser-page py-4">
            <Card className="supadd-card">
                <Card.Header className="border-bottom d-flex justify-content-between align-items-center">
                    <h6 className="m-0">{t('add_user')}</h6>
                    <div>
                        <Button variant="success" className="mb-2 mr-1" onClick={handleSubmit}>
                            <i className="fa fa-check mx-2"></i>
                            {t('save')}
                        </Button>
                        <Button variant="outline-primary" className="mb-2 mr-1" onClick={() => navigate('/supplier/users')}>
                            <i className="fa fa-times mx-2"></i>
                            {t('cancel')}
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Row className="py-4">
                            <Col lg={6} md={12} sm={12}>
                                <Form.Group controlId="name">
                                    <Form.Label>{t('username')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t('name')}
                                        value={name}
                                        className={nameError ? 'is-invalid' : ''}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <div className="invalid-feedback">{nameError}</div>
                                </Form.Group>
                                <Form.Group controlId="email">
                                    <Form.Label>{t('email')}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder={t('email')}
                                        value={email}
                                        className={emailError ? 'is-invalid' : ''}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <div className="invalid-feedback">{emailError}</div>
                                </Form.Group>
                                <Form.Group controlId="password">
                                    <Form.Label>{t('password')}</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('password')}
                                        value={password}
                                        className={mdpError ? 'is-invalid' : ''}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <div className="invalid-feedback">{mdpError}</div>
                                </Form.Group>
                                <Form.Group controlId="confirmPassword">
                                    <Form.Label>{t('confirm_password')}</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('confirm_password')}
                                        value={confirmPass}
                                        className={confMdpErr ? 'is-invalid' : ''}
                                        onChange={(e) => setConfirmPass(e.target.value)}
                                    />
                                    <div className="invalid-feedback">{confMdpErr}</div>
                                </Form.Group>
                            </Col>
                            <Col lg={6} md={12} sm={12}>
                                <Form.Group controlId="offer">
                                    <Form.Label>{t('offer_type')}</Form.Label>
                                    <Form.Select
                                        value={offerType}
                                        onChange={(e) => setOfferType(e.target.value)}
                                    >
                                        <option value="2">{t('paid')}</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
        </>
    )
}

export default AddUser
